export const DETAIL_SETTER = 'DETAIL_SETTER';
export const DETAIL_RESETTER = 'DETAIL_RESETTER';
export const DETAIL_FULL_SETTER = 'DETAIL_FULL_SETTER';
